import React, { useState } from "react";
import '../../sass/components/flexibleModules/_components.faqAccordionSection.scss';

const FaqAccordionSection = ({ data }) => {

    const [activeElement, setActiveElement] = useState("elem-a");

    const updateImage = (val) => {
        if(activeElement.substring(5) == val){
            let update = "elem-a";
            setActiveElement(update);
        }
        else{
            let update = "elem-" + val;
            setActiveElement(update);
        }
    }

    return (
        <div className={`cp-faqAccordionSection ${data.overrideClass ? data.overrideClass : "l-noOverride"}`}>
            <div className="cp-faqAccordionSection__inner l--flex" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.faqAccordionSectionHeader &&
                    <h2>{data.faqAccordionSectionHeader}</h2>
                }
                {data.faqAccordionRepeaterSections &&
                    <div className="cp-faqSection">
                        {data.faqAccordionRepeaterSections.map((faq, index) => (
                            <div className={`cp-faqSection__accordion ${activeElement === `elem-${index}` ? 'is-active' : 'inactive'}`} key={index}>
                                {faq.header &&
                                    <button data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease" className="l--flex" onClick={() => updateImage(index)}>
                                        {faq.header}
                                        <span>
                                            <span className="l-plusIcon"></span>
                                        </span>
                                    </button>
                                }
                                <div className="l--accordionHidden">
                                    {faq.content &&
                                        <div dangerouslySetInnerHTML={{ __html: faq.content }} />
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default FaqAccordionSection;